const initState =
{
  area          : null,
  hidehotspots  : false,

  tourArray     : [],
}

const toursReducer = (state = initState, action) =>
{
  switch (action.type)
  {
    case 'SET_TOUR_AREA':
      return {
        ...state,
        area: action.area
      };

    case 'SET_HIDE_HOTSPOTS':
      return {
        ...state,
        hidehotspots: action.hidehotspots
      };

    case 'SET_TOUR_ARRAY':
      return {
        ...state,
        tourArray: action.tourArray
      };

    default:
      return state; 
  }
}

export default toursReducer;